module.exports = __webpack_public_path__ + "static/media/btn_minus.f38e8e0d.svg";